import { render } from "./Otp.vue?vue&type=template&id=3599bebe&scoped=true&ts=true"
import script from "./Otp.vue?vue&type=script&lang=ts"
export * from "./Otp.vue?vue&type=script&lang=ts"

import "./Otp.vue?vue&type=style&index=0&id=3599bebe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3599bebe"]])

export default __exports__